
let config = {
    MODE: "PROD",
    PROD:"https://reworkacademy.co/app/v2",
    DEV:"http://localhost:3004/v2"
}
//https://api.reworkacademy.co/v2
export default config;
